<template>
  <div id="detail-doc">
    <div class="content-width" id="content">
      <div class="detail-doc-header">
        {{ lanInfo.title[4] }} >
        <el-select v-model="value" placeholder="请选择" @change="valueChange">
          <el-option
              v-for="item in list"
              :key="lanType == 'en' ? item.dapp_name_en : item.dapp_name"
              :label="lanType == 'en' ? item.dapp_name_en : item.dapp_name"
              :value="lanType == 'en' ? item.dapp_name_en : item.dapp_name">
          </el-option>
        </el-select>
      </div>
      <!--   在这里动态添加文档iframe   -->
    </div>
  </div>
</template>

<script>
export default {
  name: "openPlatformDetailDoc",
  data() {
    return {
      list: [], // depp列表
      value: '', // 选中option
      valueIndex: '',
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    // 监听postMessage事件
    window.addEventListener('message', this.ok)
  },
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.openPlatform;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
  methods: {
    // 获取dapp列表及相关开放平台地址
    getData() {
      this.$ajax
          .get("/webapi/blockchainDapp/queryOpendocPlatformList")
          .then(res => {
            const {code, extraData} = res.data;
            if (code == 200) {
              this.list = extraData.platformList;
              this.value = this.lanType == 'en' ? this.list[0].dapp_name_en : this.list[0].dapp_name;
              this.valueChange(this.list[0].dapp_name);
            }
          })
    },
    // iframe height change
    ok(e) {
      const iframe = document.getElementById('iframe');
      if (typeof e.data == "number") {
        iframe.style.height = e.data + 40 + 'px';
      }
    },
    // select change
    valueChange(val) {
      const index = this.list.findIndex(item => {
        return item.dapp_name_en == this.value || item.dapp_name == this.value;
      })
      this.valueIndex = index;
      const content = document.getElementById('content');
      const oldIframe = document.getElementById('iframe');
      if (oldIframe) {
        content.removeChild(oldIframe)
      }
      if (index >= 0) {
        const iframe = document.createElement('iframe');
        iframe.style.width = '100%';
        iframe.style.minHeight = '800px';
        iframe.setAttribute('id', 'iframe')
        iframe.setAttribute('scrolling', 'no')
        iframe.setAttribute('src', `${this.list[index].dapp_opendoc_url}?center&${Math.floor(Math.random()*100000)}`)
        content.appendChild(iframe);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.content-width {
  width: 1200px;
  margin: 0 auto;
}

#detail-doc {
  background: #f5f5f5;
  display: flex;
}

iframe {
  width: 100%;
  min-height: 800px;
}

.detail-doc-header {
  border-left: #1677ff 3px solid;
  font-size: 14px;
  color: #2e2e2e;
  padding-left: 13px;
  margin: 20px 0;
}

/deep/.el-select {
  width: 320px;
}
</style>